import React from 'react'
import { Break } from '../styles'

export default (): React.ReactElement<React.ComponentProps<any>, any> => {
  return (
    <>
      <h1 className='defaultTypographyH1'>Saatchi Art Collections</h1>
      <Break />
      <div>
        <p className='defaultTypographySmall'>
          Discover collections featuring our curators’ favorite artists in the most popular styles
          and mediums.
        </p>
      </div>
    </>
  )
}
